'use client';

import ClientErrorRecovery from '@/components/ClientErrorRecovery';

export default function GlobalError({
  error,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  return (
    <html lang="tr">
      <head>
        <title>Hızlı Çiçek - Türkiye’nin En Hızlı Çiçek Gönderimi</title>
        <meta
          name="description"
          content="Taptaze çiçek siparişlerinizi kendi depolarımızda hazırlıyor, kendi ustalarımızla birçok bölgede 30 dakikada çiçek gönderimi yapıyoruz."
        />
        <meta
          name="robots"
          content="index, follow, max-video-preview:-1, max-image-preview:large, max-snippet:-1"
        />
        <link rel="canonical" href="https://hizlicicek.com" />
      </head>
      <body>
        <ClientErrorRecovery boundary="global" error={error} />
      </body>
    </html>
  );
}
